const DELIVERY_METHODS_TRANSLATION_KEYS: Record<string, string> = {
    'inpost-paczkomaty-24-7': 'deliveryMethod.inpostPaczkomaty247',
    'kurier-inpost': 'deliveryMethod.kurierInpost',
    'odbior-w-punkcie': 'deliveryMethod.odborWPunkcie',
    'orlen-paczka': 'deliveryMethod.orlenPaczka'
};

export const getDeliveryDescription = (shippingCode: string) => {
    if (Object.keys(DELIVERY_METHODS_TRANSLATION_KEYS).includes(shippingCode)) {
        return DELIVERY_METHODS_TRANSLATION_KEYS[shippingCode];
    } else {
        return 'deliveryMethod.noDataToShow'
    }
}